import { DiscountVoucherModel, DiscountModel } from '@sosocio/creator/interfaces';
import ApiService from 'services/ApiService';
import { httpClient } from 'utils/http';

class DiscountService extends ApiService<DiscountModel> {
	constructor() {
		super('discount');
	}

	async saveDiscountVoucher(id: string | number, item: Omit<DiscountVoucherModel, 'id'>): Promise<DiscountVoucherModel> {
		const response = await httpClient.post(
			`${this.ENDPOINT}/${id}/voucher`,
			item,
		);
		return response.data;
	}
}

export default new DiscountService();
